export var EVENT_COLORS = {
    "Evento Pluri": {
        pure: {
            color: "#439F48",
            textColor: "#000000"
        },
        dark: {
            color: "#2E7D32",
            textColor: "#FFFFFF"
        },
        light: {
            color: "#BFF5C2",
            textColor: "#000000"
        }
    },
    "Sem Chamada(Simulado)": {
        pure: {
            color: "#8BC34A",
            textColor: "#000000"
        },
        dark: {
            color: "#557F24",
            textColor: "#FFFFFF"
        },
        light: {
            color: "#DDFFB5",
            textColor: "#000000"
        }
    },
    "Pedagógico": {
        pure: {
            color: "#FFD600",
            textColor: "#000000"
        },
        dark: {
            color: "#856F00",
            textColor: "#FFFFFF"
        },
        light: {
            color: "#FFF3B7",
            textColor: "#000000"
        }
    },
    "Esportivo": {
        pure: {
            color: "#9E6AFB",
            textColor: "#000000"
        },
        dark: {
            color: "#391873",
            textColor: "#FFFFFF"
        },
        light: {
            color: "#E0CFFF",
            textColor: "#000000"
        }
    },
    "Administrativo": {
        pure: {
            color: "#8A8787",
            textColor: "#000000"
        },
        dark: {
            color: "#4C4747",
            textColor: "#ffffff"
        },
        light: {
            color: "#C7C7C7",
            textColor: "#000000"
        }
    },
    "Festivo": {
        pure: {
            color: "#FF9800",
            textColor: "#000000"
        },
        dark: {
            color: "#854F00",
            textColor: "#ffffff"
        },
        light: {
            color: "#FFCF8A",
            textColor: "#000000"
        }
    },
    "Feriado": {
        pure: {
            color: "#16E3FD",
            textColor: "#000000"
        },
        dark: {
            color: "#007482",
            textColor: "#ffffff"
        },
        light: {
            color: "#BEF7FF",
            textColor: "#000000"
        }
    },
    "Reunião": {
        pure: {
            color: "#BC3BD2",
            textColor: "#000000"
        },
        dark: {
            color: "#5E0B6C",
            textColor: "#ffffff"
        },
        light: {
            color: "#F7C8FF",
            textColor: "#000000"
        }
    },
    "Religioso": {
        pure: {
            color: "#B38676",
            textColor: "#000000"
        },
        dark: {
            color: "#5C3E34",
            textColor: "#ffffff"
        },
        light: {
            color: "#FFDED2",
            textColor: "#000000"
        }
    },
    "Extra curricular": {
        pure: {
            color: "#03A9F4",
            textColor: "#000000"
        },
        dark: {
            color: "#00547A",
            textColor: "#ffffff"
        },
        light: {
            color: "#B8E9FF",
            textColor: "#000000"
        }
    },
    "Outros": {
        pure: {
            color: "#FFC107",
            textColor: "#000000"
        },
        dark: {
            color: "#856300",
            textColor: "#ffffff"
        },
        light: {
            color: "#FFEDB9",
            textColor: "#000000"
        }
    },
    "Avaliação": {
        pure: {
            color: "#ACBA26",
            textColor: "#000000"
        },
        dark: {
            color: "#6C760C",
            textColor: "#ffffff"
        },
        light: {
            color: "#F6FF9E",
            textColor: "#000000"
        }
    }
};
